

<div class="py-3 px-6 flex align-items-center justify-content-between relative lg:static" style="min-height: 80px;">
  <img src="assets/images/logos/Logo-Lektory-color.svg" alt="Lektory" height="40" class="mr-0 lg:mr-6">
  <a pRipple class="cursor-pointer block lg:hidden text-700" pStyleClass="@next" enterClass="hidden" leaveToClass="hidden" [hideOnOutsideClick]="true">
    <i class="pi pi-bars text-4xl"></i>
  </a>
  <div class="align-items-center flex-grow-1 justify-content-end hidden lg:flex absolute lg:static w-full left-0 top-100 z-1 shadow-2 lg:shadow-none" style="background-color: #f6f9fc;">
    <ul class="gap-2 justify-content-end list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row">
      <ng-container *ngFor="let item of basicMenuItems">
        <ng-container
          [ngTemplateOutlet]="basicMenuItem"
          [ngTemplateOutletContext]="{item: item}">
        </ng-container>
      </ng-container>
    </ul>
    <ul class="list-none p-0 m-0 flex lg:align-items-center select-none flex-column lg:flex-row border-top-1 surface-border lg:border-top-none">
      <li>
        <div class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 font-medium border-round cursor-pointer transition-colors transition-duration-150">

          <ng-container *ngIf="(userState?.user$ | async) as user; else noUser">
            <button
              (click)="onGoToAdmin(user)"
              pButton
              label="Otevřít aplikaci"
              class="p-button-success p-button-sm">
            </button>
          </ng-container>
          <ng-template #noUser>
            <!-- <button
              (click)="onCreateCourse()"
              pButton
              label="Vypsat kurz teď"
              class="p-button-success p-button-sm">
            </button> -->
            <button
              (click)="onDemo()"
              pButton
              label="Domluvit konzultaci"
              class="p-button-success p-button-sm arrange-demo-btn">
            </button>
          </ng-template>

        </div>
      </li>

      <ng-container *ngTemplateOutlet="authMenuItem"></ng-container>
    </ul>
  </div>
</div>


<ng-template #authMenuItem>
  <li class="border-top-1 surface-border lg:border-top-none">
    <ng-container *ngIf="userState?.user$ | async; else noUser">
      <app-user-menu-item
        [showName]="[DeviceSize.SM, DeviceSize.MD].includes($any(deviceSize$ | async))"
        [signOutWithoutRedirect]="true"
        class="flex px-6 p-3 lg:p-0 align-items-center hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150">
      </app-user-menu-item>
    </ng-container>
    <ng-template #noUser>
      <div
        [ngTemplateOutlet]="basicMenuItem"
        [ngTemplateOutletContext]="{item: signInItem}"
        [class.loading-box]="userState?.fetchingUser$ | async">
      </div>
    </ng-template>
  </li>
</ng-template>

<ng-template #basicMenuItem let-item="item">
  <li>
    <a (click)="item.command()" pRipple class="flex px-6 p-3 lg:px-3 lg:py-2 align-items-center text-600 hover:text-900 hover:surface-100 font-medium border-round cursor-pointer transition-colors transition-duration-150">
      <i *ngIf="item.icon as icon" class="{{ icon }} mr-2"></i>
      <span>{{ item.label }}</span>
    </a>
  </li>
</ng-template>
